<div [style.display]="userExists ? 'block' : 'none'">

  <div class="ion-hide-sm-up" *ngIf="publicProfileType !== 'my-profile' && loaded" (click)="itemClicked($event)"
    [ngClass]="{cssClass: publicProfileType === 'my-profile' ? 'inviteadmin':''}">

    <ion-row class="item-holder-mobile ion-align-items-start">
      <ion-col size="3">
        <div class="user-image-wrapper">
          <app-profile-image-item class="agentAvatar" [kioskCheck]="false" [profile]="userData.data">
          </app-profile-image-item>
          <div class="userLogoImage" *ngIf="userLogo">
            <img [src]="userLogo | safe: 'url'">
          </div>
          <div *ngIf="isRecentlyActive" class="recently-active"></div>
        </div>
      </ion-col>
      <ion-col [size]="userData.status !== 'invited' ? 7 : 9">
        <div class="agentDiv minButtonSize">
          <div class="agentName" data-cy="publicProfileItem-username">{{userData.data.username}}</div>
          <div *ngIf="agentsOpenHouseEvents.length === 0" class="agentCompany" data-cy="publicProfileItem-company">
            {{userData.data.company}}</div>

          <!-- Open house chips -->
          <div>
            <ion-chip *ngFor="let event of agentsOpenHouseEvents" class="open-house-time-chip" (click)="log(event)"
              [style.backgroundColor]="event.backgroundColor">
              <ion-icon class="white-text" name="checkmark-circle-outline" />
              <ion-label class="white-text">{{ event.extendedProps.formattedShortDate }}</ion-label>
            </ion-chip>
          </div>

          <div class="social-buttons" *ngIf="showSocialLinks">
            <ng-container *ngFor="let item of socialLinks">
              <img *ngIf="item.enabled" [src]="item.icon | safe:'url'" class="link" (click)="openSocialLink(item.URL)">
            </ng-container>
          </div>

          <!-- only show to agents for now -->
          <div *ngIf="showControls && (userData.status ==='invited'
          || userData.status === 'lender_invited_agent'
          || userData.status ==='agentadmin_invited_agent'
          || userData.status ==='agent_invited_agentadmin' )">
            <div *ngIf="(userData.data.role === 'lender'
          || userData.status ==='agent_invited_agentadmin')" class="df-align-center">
              <ion-button size="small" class="connectButton" (click)="confirmConnect($event);">Connect</ion-button>
              <ion-button size="small" class="connectButton" (click)="dismissPrompt();">Dismiss</ion-button>
            </div>

          </div>

          <!-- only show for agents for now -->
          <div *ngIf="showControls && userData.status ==='agent_invited_lender' && userData.data.role === 'agent'">
            <div class="margin-top-10 df-align-center">
              <ion-button size="small" class="connectButton" (click)="confirmConnectLender();">Connect</ion-button>

            </div>
          </div>

          <!-- only show for invite recommended -->
          <div *ngIf="!inviteLoading
          && showInvite && userData.status !=='agent_invited_lender'
          && userData.status !== 'lender_invited_agent'
          && userData.status !== 'active'
          && userData.status !== 'invited'">
            <div class="margin-top-10 df-align-center">
              <ion-button size="small" class="connectButton" (click)="inviteUser($event);"
                data-cy="publicProfileItem-location-inviteAgent">Invite</ion-button>

            </div>
          </div>

          <div class="margin-top-10 df-align-center inviteLoading" *ngIf="inviteLoading">
            <ion-spinner color="primary" name="crescent"></ion-spinner>
          </div>

          <!-- only show for agent invited lender -->
          <div *ngIf="showInvite && userData.status ==='agent_invited_lender' && userData.data.role === 'agent'">
            <div class=" margin-top-10 df-align-center">
              <ion-button size="small" class="connectButton" (click)="confirmConnectLender();">Connect</ion-button>
            </div>
          </div>

        </div>
      </ion-col>
      <ion-col class="ion-text-right" size="2" *ngIf="(userData.status === 'active' || userData.status === 'agent_admin' || userData.status === 'regionalLender')
    && showControls && !inProgress">
        <ion-button class="moreButton" size="small" fill="clear" (click)="presentPopover($event)"
          data-cy="publicProfileItem-pairedLender-moreBtn">
          <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>

  <ion-row class="item-holder ion-align-items-center ion-hide-sm-down"
    *ngIf="publicProfileType !== 'my-profile' && loaded" (click)="itemClicked($event)">
    <ion-col size="auto">
      <div class="user-image-wrapper">
        <app-profile-image-item class="agentAvatar" [profile]="userData.data"></app-profile-image-item>
        <div class="userLogoImage" *ngIf="userLogo">
          <img [src]="userLogo | safe: 'url'">
        </div>
        <div *ngIf="isRecentlyActive" class="recently-active"></div>
      </div>
    </ion-col>
    <ion-col>
      <div class="agentDiv">
        <div class="agentName" data-cy="publicProfileItem-username">{{userData.data.username}}</div>
        <div *ngIf="agentsOpenHouseEvents.length === 0" class="agentCompany" data-cy="publicProfileItem-company">
          {{userData.data.company}}</div>

        <!-- Open house chips -->
        <div>
          <ion-chip *ngFor="let event of agentsOpenHouseEvents" class="open-house-time-chip" (click)="log(event)"
            [style.backgroundColor]="event.backgroundColor">
            <ion-icon class="white-text" name="checkmark-circle-outline" />
            <ion-label class="white-text">{{ event.extendedProps.formattedShortDate }}</ion-label>
          </ion-chip>
        </div>

        <div class="social-buttons" *ngIf="showSocialLinks">
          <ng-container *ngFor="let item of socialLinks">
            <img *ngIf="item.enabled" [src]="item?.icon | safe:'url'" class="link" (click)="openSocialLink(item.URL)">
          </ng-container>
        </div>
      </div>
    </ion-col>
    <ion-col size="auto" class="horizontal-align">
      <!-- only show for regional lenders for now -->
      <div *ngIf="showContact" class="user-controls minButtonSize link">

        <ion-button fill="clear" size="small" (click)="showContactOverlay()" title="View Contact Info">
          <ion-icon *ngIf="!inProgress" slot="icon-only" class="contactIcon" name="person-circle-outline"></ion-icon>
        </ion-button>

        <ion-button fill="clear" size="small" title="Impersonate User" *ngIf="canImpersonate" (click)="impersonate()">
          <ion-icon *ngIf="!inProgress" slot="icon-only" class="contactIcon" name="id-card-outline"></ion-icon>
        </ion-button>

        <ion-button *ngIf="!regionalLender" fill="clear" size="small" title="Remove Connection"
          (click)="confirmUnpair($event)">
          <ion-icon *ngIf="!inProgress" slot="icon-only" class="contactIcon" name="remove-circle-outline"></ion-icon>
        </ion-button>
      </div>

      <!-- only show to agents for now -->
      <div *ngIf="showControls" class="user-controls actions">
        <div class="minButtonSize" *ngIf="userData.status === 'invited'
        || userData.status === 'lender_invited_agent'
        || userData.status === 'agentadmin_invited_agent'
        || userData.status === 'agent_invited_agentadmin' ">
          <div *ngIf="(userData.data.role === 'lender'
        || userData.status === 'agent_invited_agentadmin')" class="df-align-center">
            <ion-button size="small" class="connectButton" (click)="confirmConnect($event);"
              data-cy="publicProfileItem-pairedLender-connectBtn">Connect</ion-button>
            <ion-button size="small" class="connectButton" (click)="dismissPrompt();"
              data-cy="publicProfileItem-pairedLender-dismissBtn">Dismiss</ion-button>
          </div>
        </div>

        <ion-button class="moreButton" fill="clear" *ngIf="(userData.status === 'active' || userData.status === 'agent_admin' || userData.status === 'regionalLender')
      && showControls && !inProgress" (click)="presentPopover($event)"
          data-cy="publicProfileItem-pairedLender-moreBtn">
          <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
        </ion-button>

      </div>

      <!-- only show for agents for now -->
      <div class="minButtonSize"
        *ngIf="showControls && userData.status ==='agent_invited_lender' && userData.data.role === 'agent'">
        <div class="margin-top-10 df-align-center">
          <ion-button class="connectButton" (click)="confirmConnectLender();">Connect</ion-button>
          <!-- <ion-button size="small" class="connectButton" (click)="declineConnectionLender();">Dismiss</ion-button> -->
        </div>
      </div>

      <!-- only show for invite recommended -->
      <div class="minButtonSize buttonDivWrapper" *ngIf="!inviteLoading
      && showInvite
      && userData.status !=='agent_invited_lender'
      && userData.status !== 'lender_invited_agent'
      && userData.status !== 'invited'">
        <div class="df-align-center">
          <ion-button class="connectButton" (click)="inviteUser($event);">Invite</ion-button>

        </div>
      </div>

      <div class="margin-top-10 df-align-center inviteLoading" *ngIf="inviteLoading">
        <ion-spinner color="primary" name="crescent"></ion-spinner>
      </div>

      <!-- only show for agent invited lender -->
      <div class="minButtonSize buttonDivWrapper" *ngIf="showInvite && userData.status ==='agent_invited_lender'
      && userData.data.role === 'agent'">
        <div class="margin-top-10 df-align-center">
          <ion-button class="connectButton" (click)="confirmConnectLender();">Connect</ion-button>
        </div>
      </div>
    </ion-col>

  </ion-row>

  <ion-row class="item-holder ion-align-items-center inviteadmin" *ngIf="publicProfileType === 'my-profile' && loaded"
    (click)="itemClicked($event)">
    <ion-col size="4" class="invited-admin-name">
      <div class="adminName" data-cy="publicProfileItem-username">{{userData.data.username}}</div>
    </ion-col>
    <ion-col size="8" class="invited-admin-buttons">
      <div class="adminBtn">
        <ion-button (click)="confirmConnect($event, 'agentAdmin');">Connect</ion-button>
        <ion-button fill="outline" (click)="dismissPrompt();">Dismiss</ion-button>
      </div>
    </ion-col>
    <ion-col size="12" class="invite-header-col">
      <div class="invite-header" *ngIf="userData.data.role === 'agentAdmin'">
        <div class="invitedDate smallLightText">
          Team Admin invited you
        </div>
      </div>
    </ion-col>
  </ion-row>

  <!-- INVITED TEXT FOR AGENT -->
  <div *ngIf="userData.data.role === 'agent' && showInvite && loaded">
    <div class="invitedDate smallLightText" *ngIf="userData.status === 'agent_invited_lender'">
      Invited you on {{updatedDate | date: 'longDate'}}
    </div>
    <div class="invitedDate smallLightText"
      *ngIf="userData.status ==='lender_invited_agent' || userData.status === 'invited'">
      You invited on {{updatedDate | date: 'longDate'}}
    </div>
    <div class="invitedDate smallLightText" *ngIf="!userData.status
    || userData.status === 'agent_dismissed'
    || userData.status === 'agent_unpaired_lender'
    || userData.status === 'lender_unpaired_agent'
    || userData.status === 'admin_lender_removed'
    || userData.status === 'lender_dismissed'" data-cy="myPairedAgents-recommendedAgents-title">
      Active in your location
    </div>
  </div>

  <!-- INVITED TEXT FOR LENDERS -->
  <div *ngIf="(userData.data.role === 'lender') && showInvite && loaded">
    <div class="invitedDate smallLightText"
      *ngIf="userData.status ==='lender_invited_agent' || userData.status === 'invited'">
      Invited you on {{updatedDate | date: 'longDate'}}
    </div>
    <div class="invitedDate smallLightText" *ngIf="userData.status === 'agent_invited_lender'">
      You invited on {{updatedDate | date: 'longDate'}}
    </div>
    <div class="invitedDate smallLightText" *ngIf="!userData.status
    || userData.status === 'agent_dismissed'
    || userData.status === 'agent_unpaired_lender'
    || userData.status === 'lender_unpaired_agent'
    || userData.status === 'lender_dismissed'
    || userData.status === 'admin_lender_removed'" data-cy="myPairedAgents-recommendedAgents-title">
      Active in your location
    </div>
  </div>

  <!-- INVITED TEXT FOR ADMIN -->
  <div *ngIf="myRole === 'agentAdmin' && loaded && !searchInviteMode">
    <div class="invitedDate smallLightText" *ngIf="userData.status === 'agent_invited_agentadmin'">
      Invited you on {{updatedDate | date: 'longDate'}}
    </div>
    <div class="invitedDate smallLightText" *ngIf="userData.status === 'invited'">
      You invited on {{updatedDate | date: 'longDate'}}
    </div>
  </div>

  <div *ngIf="userData.data.role === 'agentAdmin' && showInvite && loaded">
    <div class="invitedDate smallLightText" *ngIf="userData.status === 'agentadmin_invited_agent'">
      Team Admin invited you on {{updatedDate | date: 'longDate'}}
    </div>
  </div>

  <div class="skeletonContainer" *ngIf="!loaded">
    <ion-skeleton-text class="rounded" animated style="height:70px; width:70px;"></ion-skeleton-text>
    <div class="skeletonSub">
      <ion-skeleton-text animated style="height:12px; width:60%;"></ion-skeleton-text>
      <ion-skeleton-text animated style="height:12px; width:50%;"></ion-skeleton-text>
      <ion-skeleton-text animated style="height:12px; width:40%;"></ion-skeleton-text>
    </div>
  </div>
</div>